const CONTRALATERAL_BREAST = 'contralateralBreast';

export default CONTRALATERAL_BREAST;
